import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { fbManufacturers, fbLooper } from '../../firebase';
import {Link} from 'react-router-dom';
export default class ManufacturersList extends Component {

    state = {
        manufacturers:[]
    }

    componentDidMount = () => {
        fbManufacturers.once('value').then((snap)=>{
            let manufacturers = fbLooper(snap);
            this.setState({
                manufacturers
            });
        });
    }

    getManufacturers = (manufacturers) =>{
        return manufacturers.map((item , i)=>{
            if(this.props.user){
                return (
                <Link to={`/edit-manufacturer/${item.id}`} key={i}>
                    <Alert color="dark">
                        {item.name}
                    </Alert>
                </Link>
                );
            }else{
                return (
                    <Alert color="dark">
                        {item.name}
                    </Alert>
                );
            }
        });
    }

  render() {
      
    return (
      <div>
        {this.state.manufacturers ? this.getManufacturers(this.state.manufacturers) : 'Loading...'}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/manufacturers_list.js